export { default as applyOneLessonTemplateMutation } from './apply-one-lesson-template-mutation';
export { default as createOneLessonTemplateMutation } from './create-one-lesson-template-mutation';
export { default as findByIdLessonTemplateQuery } from './find-by-id-lesson-template-query';
export { default as findByStudentIdLessonTemplateQuery } from './find-by-student-id-lesson-template-query';
export { default as findManyLessonTemplateQuery } from './find-many-lesson-template-query';
export { default as lessonTemplateFragment } from './lesson-template-fragment';
export { default as removeByIdLessonTemplateMutation } from './remove-by-id-lesson-template-mutation';
export { default as updateByIdLessonTemplateMutation } from './update-by-id-form-lesson-mutation';
